import { useQuery } from '@tanstack/vue-query'
import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { tradingKeys } from '../tradingQueryKeys'
import { getSellOverview } from '../tradingEndpoints'
import { parseSellOverview } from '../tradingParser'

// Exit overview + sell eligibility for one holding, keyed by PROPERTY id
// (the holding is the investor's row on the property's primary offering).
export function useSellOverviewQuery(propertyId: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: computed(() => tradingKeys.sellOverview(toValue(propertyId))),
    queryFn: () => getSellOverview(toValue(propertyId)).then(parseSellOverview),
    enabled: () => Boolean(toValue(propertyId)),
  })
}
